module.exports = __webpack_public_path__ + "img/secondary_4x2.50426f75.svg";